"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function FormatButton({ selected, iconName, onClick }) {
    const onEvent = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onClick();
    };
    return ((0, jsx_runtime_1.jsx)(Button, { onClickCapture: onEvent, type: "button", "data-e2e": 'FormatButton_Button', children: (0, jsx_runtime_1.jsx)(StyledIcon, { active: selected, name: iconName, width: 42, height: 42, "data-e2e": 'FormatButton_StyledIcon' }) }));
}
exports.default = FormatButton;
const Button = styled_components_1.default.button `
  align-items: center;

  margin: 0;
  padding: 0;

  background: none;
  border: none;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  color: ${({ theme, active }) => (active ? theme.white : theme.white_50)};

  :active {
    transform: scale(0.9, 0.9);
  }
`;
